import { render, staticRenderFns } from "./AudienceCreateAction.vue?vue&type=template&id=3fb15846"
import script from "./AudienceCreateAction.vue?vue&type=script&lang=js"
export * from "./AudienceCreateAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports